import React, { useState, useEffect, useMemo } from 'react';
import { Badge, Box, Checkbox, IconButton, ListItem, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import { EditOutlined } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import moment from 'moment';
import ParticiapntList from '../../StaffSchedule/dataList/participantLists';
import { FULL_PERMISSION } from '../../../constants/Constant';
import Helper from '../../../utility/helper';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',

    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    listItemSubActContent: {
        padding: theme.spacing(0, 0),
    },
    paperContent: {
        // boxShadow:
        //     '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // made the changes for consistent styling
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        marginBottom: theme.spacing(2),
        // backgroundColor: '#fff',
    },
    subPaperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 0, 1, 0),
        backgroundColor: '#fff',
    },
    cardRowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        padding: theme.spacing(1, 0),
    },
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
    },
}));

const ScheduleRow = React.memo((props) => {
    const classes = useStyles();
    // const { item, index } = props;
    const { item, index } = props;
    let actData = item.actualData;
    const userInfo = Helper.getStorage('userInfo');
    const isStartPast = (date) => {
        if (date) {
            var onlyStartTime = date.substring(date.length - 8);
            if (onlyStartTime === "00:00:00") {
                const today = new Date();
                today.setDate(today.getDate() - 1);
                return new Date(date) < today;
            } else {
                const today = new Date();
                return new Date(date) < today;
            }
        }
    };
    const renderActionButtons = useMemo(() => {

        return (
            <Box sx={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', pr: `${props.showUserActivity ? '16px' : '0px'}`,
                flex: `${props.showUserActivity ? '0.1' : '0.15'}`, justifyContent: 'flex-end'
            }}>
                {props.modPermission &&
                    props.modPermission == FULL_PERMISSION ?
                    <>
                        {actData.isRowPublished ? (
                            <CheckCircleIcon
                                fontSize="small"
                                style={{ color: '#008000' }}
                            />
                        ) : (
                            <UnpublishedIcon
                                fontSize="small"
                                style={{ color: '#FF5733' }}
                            />
                        )
                        }

                        {
                            !props.showUserActivity &&
                            <>
                                <Tooltip title="Add Participants" aria-label="add-participants">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.handleAddParticipants(item)}
                                        disabled={
                                            item.disableRow != undefined
                                                ? item.disableRow
                                                : false
                                        }>
                                        <GroupAddIcon
                                            fontSize="small"
                                            color={
                                                item.disableRow != undefined
                                                    ? 'default'
                                                    : 'primary'
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="View Participants" aria-label="view-participants">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.handleViewParticipants(item)}
                                        disabled={
                                            item.disableRow != undefined
                                                ? item.disableRow
                                                : false
                                        }>
                                        <Badge badgeContent={actData.participants && actData.participants.length > 0 ? actData.participants.length : 0} color="primary">
                                            <PeopleAltIcon
                                                fontSize="small"
                                                color={
                                                    item.disableRow != undefined
                                                        ? 'default'
                                                        : 'primary'
                                                }
                                            />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit" aria-label="edit">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.editRow(item)}
                                        disabled={
                                            item.disableRow != undefined
                                                ? item.disableRow
                                                : false
                                        }>
                                        <EditOutlined
                                            fontSize="small"
                                            color={
                                                item.disableRow != undefined
                                                    ? 'default'
                                                    : 'primary'
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </>
                        }
                    </>
                    : null}
            </Box>
        )
    }, [props.modPermission, props.item.actualData, props.item.disableRow, props.showUserActivity])

    const renderScheduleContent = useMemo(() => {
        return (
            <>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: `${props.showUserActivity ? '0.1' : '0.08'}`, justifyContent: 'left', }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start' }}>
                        {actData?.startDateTime ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Activity Date
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {moment(actData.startDateTime).format('MM/DD/YYYY')}
                                    </span>
                                </Typography>
                            </>
                            : null}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: `${props.showUserActivity ? '0.1' : '0.07'}`, justifyContent: 'left', }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start' }}>
                        {actData?.startTime ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Start Time
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {moment(actData.startDateTime).format('hh:mm A')}
                                    </span>
                                </Typography>
                            </>
                            : null}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: `${props.showUserActivity ? '0.1' : '0.09'}`, justifyContent: 'left', }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start' }}>
                        {actData?.endTime ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    End Time
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {moment(actData.endDateTime).format('hh:mm A')}
                                    </span>
                                </Typography>
                            </>
                            : null
                        }
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: `${props.showUserActivity ? '0.3' : '0.2'}`, justifyContent: 'left', }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            // color={row.key == 'activityName' ? 'secondary' : null}
                            fontWeight={600}>{actData.activityName}</Typography>
                        {actData.notes ?
                            <Typography
                                fontSize={11}
                                sx={{
                                    wordBreak: 'break-word',
                                    fontWeight: 'bold'
                                }}>
                                Notes: {actData.notes}
                            </Typography>
                            : null}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: `${props.showUserActivity ? '0.2' : '0.1'}`, justifyContent: 'left', }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', paddingLeft: '4px' }}>
                        {actData.attire ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Attire
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {actData.attire}
                                    </span>
                                </Typography>
                            </>
                            : null}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: `${props.showUserActivity ? '0.12' : '0.15'}`, justifyContent: 'left', }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', paddingLeft: '4px' }}>
                        {actData.location ?
                            <>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Location
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {actData.location}
                                    </span>
                                </Typography>
                            </>
                            : null}
                    </Box>
                </Box>
            </>
        )
    }, [props.item.actualData, props.showUserActivity]);
    let isPastDate = false;
    if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
        isPastDate = false
    } else {
        if (actData.endDateTime !== null) {
            isPastDate = isStartPast(actData.endDateTime)
        } else {
            isPastDate = isStartPast(actData.startDateTime)
        }
    }
    return (
        <Box className={classes.paperContent}>
            <Box className={classes.cardRowContent} sx={{ opacity: isPastDate ? '0.4' : '1', background: isPastDate ? 'lightgrey' : 'none' }}>
                <>
                    {
                        !props.hideCheckBox &&
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.05', justifyContent: 'center' }}>
                            <Checkbox
                                inputProps={{
                                    'aria-label': 'Participant',
                                }}
                                checked={item.selected ? item.selected : false}
                                onChange={(event) => props.onCheckSelect(event, item)}
                                //value={actData.activityID}
                                sx={{ marginLeft: theme.spacing(-1) }}
                            />
                        </Box>
                    }
                    {renderScheduleContent}

                    {
                        !props.showUserActivity &&

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.18', justifyContent: 'left', }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', paddingLeft: '4px' }}>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Participants
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'inline',
                                        flexDirection: 'row',

                                    }}
                                    component="div"
                                >

                                    <ParticiapntList item={item} participant={true} subActivitiy={false} endUser={false} />
                                </Box>
                            </Box>
                        </Box>
                    }

                    {renderActionButtons}
                </>
            </Box>
        </Box>
    )
});
export default ScheduleRow;